import { api } from "./index";
import type { Claim } from "../pages/claims/types";

export const getClaim = (claimNumber: string) => {
  return api.get<Claim>(`/webapp/claims/${claimNumber}`);
};
